import React, { Fragment, useEffect, useState } from 'react';
import { getAlpSearch, getSearch } from '../services/visa.tsx';
import { PackageVisa } from '../ts/PackageResponse.tsx';
import { getPacImg } from '../utils.tsx';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getPage, PageItem } from '@bepro-travel/fe.shared';

const PackagesPage = () => {
  const [packages, setPackages] = useState<PackageVisa[]>([]);
  const navigate = useNavigate();
  const [urlParams] = useSearchParams();
  const [data, setData] = useState<PageItem>();
  const [dest, setDest] = useState<any>();

  useEffect(() => {
    (async () => {
      if (sessionStorage.getItem('alpToken')) {
        const res = await getAlpSearch(
          urlParams.get('countryCode') || '',
          sessionStorage.getItem('alpToken')!
        );
        if (res?.availablePackages) {
          setPackages(res.availablePackages);
        }
        if (res?.destinationPage) {
          setDest(res.destinationPage);
        }
      } else {
        const res = await getSearch(urlParams.get('countryCode') || '');
        if (res?.availablePackages) {
          setPackages(res.availablePackages);
        }
        if (res?.destinationPage) {
          setDest(res.destinationPage);
        }
      }
    })();

    (async () => {
      const newdata = await getPage('pages/packages');
      const pageItem = newdata?.pageItems.find(
        (pi) => pi.cmsAttribute === 'cmsContent_1'
      );
      setData(pageItem);
    })();
  }, []); // eslint-disable-line

  const onSelectPackage = (pac: PackageVisa) => {
    sessionStorage.setItem('selectedPackage', JSON.stringify(pac));
    navigate('/book?id=' + pac.id);
  };

  return (
    <div dir="rtl">
      <div>
        {!!getPacImg(dest, true) && (
          <img className="pac-img" src={getPacImg(dest, true)} alt="1" />
        )}

        <div className="home-titles mb-15">
          פותחים דלת לכל יעד עם ויזה בקליק
        </div>
      </div>
      <div className="pac-wr">
        {!!packages?.[0] && (
          <Fragment>
            <div className="flex-row pac-head">
              {!!getPacImg(dest, false) && (
                <img src={getPacImg(dest, false)} alt="1" />
              )}

              <div>
                <div className="text-bold">{packages[0].productName}</div>
                <div>{packages[0].productSubName2}</div>
              </div>
            </div>
          </Fragment>
        )}

        {!!data?.pageContent?.body && (
          <div
            dangerouslySetInnerHTML={{ __html: data.pageContent.body }}
          ></div>
        )}

        {!!dest?.languages?.[0].title.body && (
          <div
            className="text-lh"
            dangerouslySetInnerHTML={{
              __html: dest?.languages?.[0].title.body,
            }}
          ></div>
        )}

        <div className="flex-row pac-card-wr">
          {packages.map((item, index) => (
            <div
              key={index}
              className="pac-card"
              onClick={() => onSelectPackage(item)}
            >
              <div className="title-blue mt-10 mb-10">{item.productName}</div>
              <div className="mb-10">{item.productSubName1}</div>
              <div className="mb-20">{item.productSubName2}</div>
              <div className="mb-10">
                מחיר לאדם {item.pricePerPax} {item.currencySymbol}
              </div>
              <div className="pac-card-btn">להזמנת ויזה לחצו כאן</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PackagesPage;
